/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardViolationByRegionCount {
    getFixupPrototypeFunction() { return SecurityDashboardViolationByRegionCount.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardViolationByRegionCount>): SecurityDashboardViolationByRegionCount {
        let obj = Object.assign(new SecurityDashboardViolationByRegionCount(), model);
        SecurityDashboardViolationByRegionCount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardViolationByRegionCount>): SecurityDashboardViolationByRegionCount {
        if (!model) return null;
        return SecurityDashboardViolationByRegionCount.newInstance(<SecurityDashboardViolationByRegionCount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardViolationByRegionCount) {
        if (!obj) return;

        models.SecurityDashboardViolationByRegionCount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardViolationByRegionCount): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardViolationByRegionCount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.guardrail_violation_count === undefined) {
            this.guardrail_violation_count = 0;
        }
    }

    /**
     * Visibility for the Cloud Provider
     */
    cloud_provider: models.CloudServiceName;

    /**
     * Config Violation Count by region name
     */
    region: string;

    /**
     * Violation Total Count by region
     */
    guardrail_violation_count: number;

}
